import { useEffect, useState } from "react";

const KEY = "empro_b2b_cart";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (a) => { localStorage.setItem(KEY, JSON.stringify(a)); window.dispatchEvent(new Event("b2bcart")); };

export const getCart = () => read();
export const cartCount = () => read().reduce((n, l) => n + (l.quantity || 0), 0);
export const cartSubtotal = () => read().reduce((n, l) => n + (l.price_grosz || 0) * (l.quantity || 0), 0);

export function addSizes(product, color, variant, sizesObj) {
  const a = read();
  let added = 0;
  const vId = variant?.id || "";
  const photo = variant?.photo || (product.color_photos || {})[color] || (product.photos || [])[0] || "";
  Object.entries(sizesObj || {}).forEach(([size, qty]) => {
    const q = parseInt(qty) || 0;
    if (q <= 0) return;
    const i = a.findIndex((l) => l.product_id === product.id && l.color === color && (l.variant_id || "") === vId && l.size === size);
    if (i >= 0) a[i].quantity += q;
    else a.push({ product_id: product.id, store_id: product.store_id, name: product.name, photo, price_grosz: product.price_grosz, color, variant_id: vId, variant_name: variant?.name || "", print_color: variant?.print_color || "", size, quantity: q });
    added += q;
  });
  if (added) write(a);
  return added;
}

export const setQty = (i, q) => { const a = read(); if (!a[i]) return; a[i].quantity = Math.max(1, parseInt(q) || 1); write(a); };
export const removeLine = (i) => { const a = read(); a.splice(i, 1); write(a); };
export const clearCart = () => write([]);

export function useB2bCart() {
  const [v, setV] = useState(read());
  useEffect(() => {
    const f = () => setV(read());
    window.addEventListener("b2bcart", f);
    window.addEventListener("storage", f);
    return () => { window.removeEventListener("b2bcart", f); window.removeEventListener("storage", f); };
  }, []);
  return v;
}
